export function resetCSS() {
  const dataPrivacyFooter = document.getElementById('dataPrivacyFooter');
  const resetStyles = dataPrivacyFooter?.getAttribute('data-reset-styles');

  return resetStyles === 'true';
}
